import dayjs from 'dayjs'
import { KOLAnalyze } from '@/api/workspaces-api'
import { DEFAULT_DATE_FORMAT } from '@/constants/date-format'
import { MergedKOLAnalyze } from '@/utils/detail/group-by-granularity'

const mergeZeroData = (
  timeData: KOLAnalyze[],
  duration: number,
  mockContent?: Partial<KOLAnalyze>,
): MergedKOLAnalyze[] => {
  const lastDate = dayjs()
  const targetDate = lastDate.subtract(duration, 'month')
  const zeroData = Array.from(
    { length: lastDate.diff(targetDate, 'day') },
    (_, index): MergedKOLAnalyze => {
      const publishedAt = targetDate
        .add(index, 'day')
        .format(DEFAULT_DATE_FORMAT)
      return {
        url: '',
        likeCount: 0,
        interactiveCount: 0,
        interactiveRate: 0,
        commentCount: 0,
        shareCount: 0,
        titleContent: '',
        viewCount: 0,
        viewRate: 0,
        isVideo: false,
        isLive: false,
        isShort: false,
        isAdvertorial: false,
        repostAndQuoteCount: 0,
        postId: '',
        igPostId: '',
        crawledId: '',
        thumbnail: '',
        ...mockContent,
        publishedAt,
        mockData: true,
      }
    },
  )
  return [...timeData, ...zeroData]
}

export default mergeZeroData
